import { useQuery } from '@tanstack/react-query';
import { measurementTypeService } from '../services/measurement-type.service';
import { PaginationParams } from '../types/common';

const MEASUREMENT_TYPES_KEY = 'measurement-types';

export const useMeasurementTypes = (
  params?: PaginationParams & { isActive?: boolean }
) => {
  return useQuery({
    queryKey: [MEASUREMENT_TYPES_KEY, params],
    queryFn: () => measurementTypeService.findAll(params).then((res) => res.data),
  });
};

export const useMeasurementType = (id: string) => {
  return useQuery({
    queryKey: [MEASUREMENT_TYPES_KEY, id],
    queryFn: () => measurementTypeService.findById(id).then((res) => res.data),
    enabled: !!id,
  });
};

